import {JsFormResponseHandlerObject} from '../jsFormTypes';
import {JRpcResponse} from '../jsonRpc/jsonRpcResponseFactory';
import {Localization} from '../../../localization/localization';
import {ErrorToolTip, TooltipDirection} from '../../newErrorToolTip';
import {isValidEmail} from '../validators';
import { disableJsFormHandler } from '../jsForm';
import {GtmSender} from '../../../marketing/GtmSender';
import {SystemEvents} from '../../../constants/gameEvents';
import {StretchPopup} from '../../../popups/stretchPopup';
import { AuthStepConversionSend } from '../../../marketing/auth-step-conversion-send';
import {getErrorMessage} from './getErrorMessage';
import {getUrlToLoginViaToken} from '../../../login/getUrlToLoginViaToken';
import {addLoginQueryParams} from '../../../utils/url';
import {appendUnityLoginIframe} from '../../../utils/landing';
import {getHubApi} from '../accountServiceApi/getAccountServiceApi';
import {
    EmailOtpRegistrationRequest,
    RequestEmailOtpRegRequest
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/registration-otp-req';
import { JRpcErrorStruct } from '../jsonRpc/jRpcErrResponse';

function getFormContainer(caller: HTMLElement|JQuery<HTMLElement>) {
    return $(caller).closest('.js-main');
}

let errorToolTip: ErrorToolTip;
let otpEmail :string|null = null;

const state = {
    allowResend: 0,
    isResend: false
};

let countDown: number;

function updateCounter() {
    const now = new Date().getTime();
    const delta = state.allowResend ? state.allowResend - now : 0;
    if (delta < 0) {
        clearInterval(countDown);
        displayReturnText();
        return;
    }
    updatePopupText(delta);
}

function displayReturnText() {
    $('.otp-resend-info').html(Localization._n('accounting.OTP_window.resend_code'));
    $('.otp-resend-info a').on('click', function(e) {
        e.preventDefault();
        resendOtp();
    });
}

async function resendOtp() {
    $('.pin-input').val('');
    state.isResend = true;
    state.allowResend = new Date().getTime() + 1000 * 60;
    updateCounter();
    const newOtpRequest: RequestEmailOtpRegRequest = {
        email: otpEmail,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    const hubApi = getHubApi();
    const res = await hubApi.requestEmailOtpReg(window.app.deviceIdentifier, newOtpRequest);
    if ('error' in res) {
        state.allowResend = 0;
        updateCounter();
        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('.otp-resend-info a'),
            TooltipDirection.RIGHT,
            res.error.message
        );
    } else {
        if (countDown) {
            clearInterval(countDown);
        }
        countDown = window.setInterval(() => {
            updateCounter();
        }, 1000);
    }
}

function updatePopupText(delta:number) {
    const minutes = Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60));
    let seconds:number|string = Math.ceil((delta % (1000 * 60)) / 1000);
    if (seconds < 10) {
        seconds = `0${seconds}`;
    }
    let translationKey = '';
    if (state.isResend) {
        translationKey = 'accounting.OTP_window.code_resend_resend_code_after';
    } else {
        translationKey = 'accounting.OTP_window.resend_code_after';
    }
    $('.otp-resend-info').html(Localization._n(
        translationKey,
        {
            minutes: `${minutes}`,
            seconds: `${seconds}`
        }
    ));
}

export function initRegistrationWithOtpForm() {
    $(function initRegistrationWithOtpForm() {
        errorToolTip = ErrorToolTip.getTooltipElement();

        $('.js-close-button-reg').on('click', function handleCloseButtonClick() {
            const main = getFormContainer(this);
            main.removeClass('step1 step2');
            main.addClass('step1');
            StretchPopup.stretch();
        });

        $('.js-form .button-back').on('click', function handleBackButtonClick() {
            const main = getFormContainer(this);
            main.removeClass('step1 step2');
            main.addClass('step1');
            StretchPopup.stretch();
        });
    });
    window.app.registrationWithOtpStep1 = registrationWithOtpStep1;
    window.app.registrationWithOtpStep2 = registrationWithOtpStep2;
}

function registrationWithOtpStep1(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const $form = data.form;
    const $termsCheckbox = $('.js-terms_agree', $form);
    const email = $('input[name=email]', $form).val() as string;
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
    const emailInput = $('input[name=email]', data.form);
    const emailInputContainer = emailInput.parents('.white_input');

    $('.error', data.form).removeClass('error');

    if ($termsCheckbox.length && !$termsCheckbox.hasClass('checked')) {
        errorToolTip.showTooltipElement(
            $termsCheckbox,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('agree_error'),
            true
        );

        return false;
    }

    if (!isValidEmail(email)) {
        emailInputContainer.addClass('error');
        errorToolTip.showTooltipElement(
            emailInput,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('wrong_data')
        );
        return false;
    }


    otpEmail = email;

    const newOtpRequest: RequestEmailOtpRegRequest = {
        email,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    const hubApi = getHubApi();
    hubApi.requestEmailOtpReg(
        window.app.deviceIdentifier,
        newOtpRequest
    ).then(() => {
        const descriptionText = $('.otp-login-info', data.form);
        descriptionText.html(Localization._n('accounting.OTP_window.description', {value: otpEmail}));
        const delay = window.app.config?.otp?.delay ?? 1000 * 60;
        state.allowResend = new Date().getTime() + delay;
        updateCounter();
        if (countDown) {
            clearInterval(countDown);
        }
        countDown = window.setInterval(() => {
            updateCounter();
        }, 1000);
        $('.pin-input', data.form).val('');
        const authStepConversionSender = new AuthStepConversionSend(window.location);
        authStepConversionSender.send('2');
        const formBlock = getFormContainer(data.caller);
        formBlock.removeClass('step1 step2');
        formBlock.addClass('step2');
        data.caller.removeAttr('disabled');
        StretchPopup.stretch();
    })
        .catch((exception) => {
            if (exception.name === 'RpcReceivedError') {
                emailInputContainer.addClass('error');
                errorToolTip.showTooltipElement(
                    emailInput,
                toolTipDirectionSide as TooltipDirection,
                getErrorMessage(exception.code, exception.data)
                );
            } else {
                emailInputContainer.addClass('error');
                errorToolTip.showTooltipElement(
                    emailInput,
                toolTipDirectionSide as TooltipDirection,
                Localization._n('errors.common_error')
                );
            }
        });

    return false;
}


async function registrationWithOtpStep2(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    $('.error', data.form).removeClass('error');
    const otpValue = $('.pin-input', data.form).toArray()
        .map((input: HTMLInputElement) => input.value)
        .join('')
        .toUpperCase();
    const registerRequest: EmailOtpRegistrationRequest = {
        email: otpEmail,
        otp: otpValue,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    try {
        const hubApi = getHubApi();
        const response = await hubApi.emailOtpRegistration(
            window.app.deviceIdentifier,
            registerRequest
        );
        if (!('error' in response)) {
            window.app.user_huid = response.accountId;
            GtmSender.fireMarketing(SystemEvents.EMAIL_REG_SUCCESS);
            disableJsFormHandler(data.caller);
            let url = getUrlToLoginViaToken(response?.tether.token, response?.tether.suid);
            url = addLoginQueryParams(url);
            appendUnityLoginIframe(url);
        } else {
            let toolTipDirection : TooltipDirection;
            const input = $('.pin-container', data.form);
            if (data.form.parents('.forms2').length) {
                toolTipDirection = TooltipDirection.RIGHT;
            } else {
                toolTipDirection = TooltipDirection.LEFT;
            }
            const error = response.error as JRpcErrorStruct;
            ErrorToolTip.getTooltipElement().showTooltipElement(
                input,
                toolTipDirection,
                getErrorMessage(error.code, response)
            );
            input.addClass('error');
        }
    } catch (exception) {
        console.error(exception);
        window.Sentry.captureException(exception);
        const input = $('.pin-container', data.form);
        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            TooltipDirection.RIGHT,
            Localization._n('errors.common_error')
        );
    }
}


